import { Banknote, ShoppingBag, Users, PackageSearch } from 'lucide-react';
import { AdminStatCard } from '../primitives/admin-stat-card.js';
import { formatCount, formatPaise } from '../../lib/format.js';
import type { DashboardOverviewDto } from '../../types/dashboard.js';

export interface KpiGridProps {
  overview: DashboardOverviewDto | undefined;
  isLoading: boolean;
}

/** The four headline KPI tiles -- revenue/orders/customers/inventory, each with a period-over-period trend. See docs/admin-analytics-definitions.md for the exact definition of every value shown here. */
export function KpiGrid({ overview, isLoading }: KpiGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <AdminStatCard
        label="Net revenue"
        value={overview ? formatPaise(overview.revenue.netPaise) : '—'}
        trendPercent={overview?.revenue.trendPercent}
        icon={<Banknote className="h-4 w-4" />}
        isLoading={isLoading}
      />
      <AdminStatCard
        label="Orders"
        value={overview ? formatCount(overview.orders.total) : '—'}
        trendPercent={overview?.orders.trendPercent}
        icon={<ShoppingBag className="h-4 w-4" />}
        isLoading={isLoading}
      />
      <AdminStatCard
        label="Active customers"
        value={overview ? formatCount(overview.customers.active) : '—'}
        trendPercent={overview?.customers.trendPercent}
        icon={<Users className="h-4 w-4" />}
        isLoading={isLoading}
      />
      <AdminStatCard
        label="Low-stock variants"
        value={overview ? formatCount(overview.inventory.lowStockVariants) : '—'}
        icon={<PackageSearch className="h-4 w-4" />}
        isLoading={isLoading}
      />
    </div>
  );
}
